import { PayloadAction } from '@reduxjs/toolkit';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { ENUM__redux_action } from '../../../_base/ENUM__redux_action';
import { try_remove_user_task_from_load_generations_set } from '../../_methods/try_remove_user_task_from_load_generations_set';
import { STATE__generation } from '../../STATE__generation';

export const local_user_task_update_without_generatons = (payload: DTO__user_task[]): PayloadAction<DTO__user_task[]> => ({
  type: ENUM__redux_action.USER_TASK_UPDATE_WITHOUT_GENERATIONS,
  payload,
});

export const init_local_user_task_update_without_generations = (state: STATE__generation, action: PayloadAction<DTO__user_task[]>) => {
  if (action.payload.is_empty()) return;

  for (let user_task_update of action.payload) {
    assert_not_null(user_task_update._id);

    let user_task_existing = state.user_tasks_map.get(user_task_update._id);

    try_update_user_task(user_task_existing, user_task_update);
    try_remove_user_task_from_load_generations_set(state, user_task_update);

    if (state.user_task_current._id == user_task_update._id) {
      try_update_user_task(state.user_task_current, user_task_update);

      //need to trigger rerender
      state.user_task_current = new DTO__user_task().clone(state.user_task_current);
    }
  }

  //need refresh user_taks_map to rerender components
  state.user_tasks_map = new Map(state.user_tasks_map);
};

function try_update_user_task(user_task: DTO__user_task | undefined, user_task_update: DTO__user_task) {
  if (!user_task) return; //could be null when user is still not received user tasks during auth
  if (user_task._id != user_task_update._id) return;

  let key_generations: keyof DTO__user_task = 'generations';

  for (let key of Object.keys(user_task_update)) {
    if (key == key_generations) continue;

    (user_task as any)[key] = (user_task_update as any)[key];
  }
}
